import { Collapse, CollapseItem, Upload, DatePicker, TimeSelect, Checkbox, Table, TableColumn, Tag, Input, Button, Select, Option, Popover } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import VueTimepicker from 'vue2-timepicker';
import { Switch as LSwitch } from '@/components/index';
import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
const svc = new ResourceSvc();
import store from '@/services/store';

export default {
    name: 'dashboardRaceRegistrations',
    props: ['userId'],
    components: {
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [VueTimepicker.name]: VueTimepicker,
        [Checkbox.name]: Checkbox,
        [Table.name]: Table, [TableColumn.name]: TableColumn, [DatePicker.name]: DatePicker, [TimeSelect.name]: TimeSelect, [Tag.name]: Tag, [Input.name]: Input, [Select.name]: Select, [Option.name]: Option, [Upload.name]: Upload, [Button.name]: Button, [Popover.name]: Popover, LSwitch,
    },
    data() {
        return {
            loadedUserId: 0,
            transferId: null,
            isProcessing: false,
            errorMessage: null,
            tableData: [],
            years: [],
            selectedYear: 0,
            user: null,
            logo: require("../../../../../../images/logo.png"),
            sucsessTransferMessage: null,
            erorreTransferMessage: null,
            isAgreeWithPolicy: false
        };
    },
    computed: {
        isValidInput() {
            let validArray = [];
            if (this.raceDetailsOld.CustomObject.RaceDetail.AskWhatSchool) {
                validArray.push(this.isValidWhatSchool);
            }
            if (this.raceDetailsOld.CustomObject.RaceDetail.AskWhereHear) {
                validArray.push(this.isValidWhereHear);
            }
            if (this.raceDetailsOld.CustomObject.RaceDetail.AskBikeTime) {
                validArray.push(this.isValidBikeTIme);
            }
            if (this.raceDetailsOld.CustomObject.RaceDetail.AskSwimTime) {
                validArray.push(this.isValidSwimTIme);
            }
            if (this.raceDetailsOld.CustomObject.RaceDetail.AskRunTime) {
                validArray.push(this.isValidRunTIme);
            }

            validArray.push(this.isValidMedicalAnswer);
            validArray.push(this.isAcceptedTerms);
            if (validArray.some(x => x == false)) {
                return false;
            }
            else { return true; }
        },
        racesBySelectedYear() {
            var self = this;
            if (!self.tableData) {
                return []
            }
            var data = self.tableData.filter(x => {
                return x.year == self.selectedYear;
            });

            if (data && data.length) {
                return data[0].races;
            }
            return [];
        },
        isValidTransferId() {
            if (this.transferId && this.transferId.indexOf(" ") > -1) {
                this.transferId = this.transferId.split(" ").join("");
            }

            return !isNaN(this.transferId) && this.transferId && this.transferId.length > 6;
        },
        userTransferId() {
            if (this.isValidTransferId) {
                return Number(this.transferId) + 100000 - 10000000
            }

            return null;
        }
    },
    methods: {
        isValidTimes(estimatedTime) {
            if (estimatedTime) {
                try {
                    if (estimatedTime == null || estimatedTime == '00:00:00' || estimatedTime == '' || estimatedTime.includes('HH') || estimatedTime.includes('mm') || estimatedTime.includes('ss')) {
                        return false;
                    } else return true;
                }
                catch (e) {
                    if (typeof (estimatedTime) == "object" && estimatedTime.HH && estimatedTime.mm && estimatedTime.ss) {
                        return true;
                    }
                    else return false;
                }

            }
        },
        openInNewTabPolicy(url) {
            if (this.isAgreeWithPolicy) {
                this.openInNewWindow(url);
                this.isAgreeWithPolicy = true;
            }
        },
        openInNewWindow(url) {
            var win = window.open(url, '_blank');
            win.focus();
        },
        checkTransfer(item) {
            let self = this;
            if (self.userId < -2) {
                return;
            }
            if (self.userId && (self.loadedUserId < -2 || self.loadedUserId == 0)) {
                self.loadedUserId = self.userId;
            }
            self.erorreTransferMessage = null;
            if (!self.isValidTransferId || !self.isAgreeWithPolicy) { return; }
            svc.checkTransferAvailability(self.loadedUserId, self.userTransferId, item.raceId)
                .then(response => {
                    if (response && response.body && response.body && response.body.isSuccess) {
                        if (confirm(response.body.successMessage)) {
                            self.doRaceTransfer(item);
                        }
                    } else {
                        self.$showError(response.body.message);
                        self.erorreTransferMessage = response.body.message;
                    }
                },
                    err => {
                        self.$showError(response.body.message);
                        self.erorreTransferMessage = response.body.message;
                    });

        },
        doRaceTransfer(item) {
            let self = this;
            if (!self.isValidTransferId) { return; }
            svc.doRaceTransfer(self.userTransferId, item.raceId, item.raceOpeningId, item.id)
                .then(response => {
                      if (response && response.ok) {
                          self.$showSuccess();
                        self.getData();
                    } else {
                        self.$showError();
                    }
                },
                    err => {
                        self.$showError();
                    });
        },
        setUser() {
            this.user = store.getters.getCurrentUserShortInfo;
            if (this.user && this.user.details && !this.user.details.isAdult) {
                var parent = store.getters.getUserShortInfo;
                this.user.details.email = parent.details.email;
                this.user.details.phone = parent.details.phone;
            }
            else {
                this.user = store.getters.getUserShortInfo;
            }
            this.$console(this.user);
        },
        getData() {
            var self = this;
            self.isProcessing = true;

            if (self.userId < -2) {
                return;
            }

            if (self.userId && (self.loadedUserId < -2 || self.loadedUserId == 0)) {
                self.loadedUserId = self.userId;
            }

            if (self.userId != -1) {
                EventBus.$emit("user-load-dashboard-card", self.loadedUserId);
            }
            var data = { userId: self.loadedUserId };
            svc.getRacesRegistrations(data).then(response => {
                var allData = response.body;
                self.isProcessing = false;
                if (!allData) {
                    self.errorMessage = "Something went wrong!";
                    return;
                }
                if (!allData.isSuccess) {
                    self.errorMessage = allData.message;
                    return;
                }
                else {
                    self.errorMessage = null;
                    self.tableData = allData.raceByYears;
                    self.years = allData.years;
                    if (self.years && self.years.length) {
                        self.selectedYear = self.years[0];
                    }
                }

                self.$console();
                self.$console({ races: self.tableData });

                if (!self.user) {
                    self.setUser();
                }

                return self.tableData;
            }, () => {
                self.isProcessing = false;
                self.errorMessage = "Something went wrong, please contact with dev team!";
            });
        },
        downloadODM(id) {
            var doc = new jsPDF();
            var source = window.document.getElementById("odm" + id);
            var logo = document.getElementById("logo");
            doc.addImage(logo.src, 'JPEG', 10, 10, 32, 34);
            doc.fromHTML(source, 10, 45);
            doc.save("odm_" + id + ".pdf");
        },
        convertDatePickerIfNull(item) {
            if (item && typeof (item) == "object" && item.HH && item.mm && item.ss) {
                return item.HH + ":" + item.mm + ":" + item.ss;
            }
            else return item;

        },
        saveEstimateTimes(item) {
            let self = this;
            if (!item && !item.id) { return; }

            if (item.estimatedBikeTime || item.estimatedRunTime || item.estimatedSwimTime) {
                if (item.estimatedSwimTime == '00:00:00' || item.estimatedRunTime == '00:00:00' || item.estimatedBikeTime == '00:00:00') {
                    return;
                }
            }

            item.estimatedSwimTime = self.convertDatePickerIfNull(item.estimatedSwimTime);
            item.estimatedRunTime = self.convertDatePickerIfNull(item.estimatedRunTime);
            item.estimatedBikeTime = self.convertDatePickerIfNull(item.estimatedBikeTime);

            self.isProcessing = true;
            svc.postSaveRaceEstimateTimes(item.id, item.estimatedBikeTime, item.estimatedSwimTime, item.estimatedRunTime)
                .then(res => {
                    if (res && res.body && res.body.isSuccess) {
                        self.isProcessing = false;
                        self.$showSuccess("Data is saved successfully");
                    }
                    else {
                        self.$showError(res && res.body && res.body.message ? res.body.message : null, 5000);
                    }
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError(5000);
                    });
        }
    },
    created() {
        var self = this;
        self.getData();
        EventBus.$off('user-load-race-registrations');
        EventBus.$on("user-load-race-registrations", (id) => {
            self.loadedUserId = id;
            self.getData();
        });

        EventBus.$off('view-race-ragistration-load-user');
        EventBus.$on('view-race-ragistration-load-user', () => {
            self.setUser();
        });
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race-registrations/view-race-registrations.js